import { render, staticRenderFns } from "./SummaryCards.vue?vue&type=template&id=f1a2467e"
import script from "./SummaryCards.vue?vue&type=script&lang=js"
export * from "./SummaryCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports